import React from 'react';
import { Button as AntdButton, ButtonProps as AntdButtonProps } from 'antd';
import { EditIcon } from '~/img';
import colors from '~/constants/colors';
import { useDirection } from '~/hooks/i18nHooks';

interface Props extends AntdButtonProps {
  disabled: boolean;
  hasError?: boolean;
  toolTipComponent?: any;
  hasValidationWarnings?: boolean;
}

const EditButton: React.FC<Props> = (props) => {
  const { hasValidationWarnings, hasError, ...rest } = props;
  const dir = useDirection();
  return (
    <AntdButton
      size="middle"
      type="default"
      style={hasError ? waningStyle : undefined}
      icon={<EditIcon dir={dir} />}
      {...rest}
    />
  );
};

const waningStyle = { color: colors.errorColor, borderColor: colors.errorColor };

export default EditButton;
